import { Fragment, ReactNode } from 'react';

import InfiniteScroll, { InfiniteScrollData } from '@/components/molecules/infinite-scroll';
import ScrollTopStickyButton from '@/components/molecules/scroll-top-sticky-button';
import { QnaQuestionMobileCard } from '@/types/qna';
import { KeywordSearchQuestionVo } from '@/types/search';

import QuestionsSkeleton from './QuestionsSkeleton';
import QuestionItem, { QuestionItemProps } from './question-item';
import EmptyQuestionList, {
  EMPTY_QUESTIONS_BOTTOM_BUTTON_TYPE,
  EmptyQuestionListMessage,
} from './question-item/empty-question-list';

export interface QuestionListProps extends Omit<QuestionItemProps, 'questionCard'> {
  questionCard: InfiniteScrollData<Array<QnaQuestionMobileCard | KeywordSearchQuestionVo>>;
  bottomButtonType?: EMPTY_QUESTIONS_BOTTOM_BUTTON_TYPE;
  emptyMessage?: EmptyQuestionListMessage;
  pageName: string;
  emptyComponent?: ReactNode;
  advertisementComponent?: ReactNode;
}

const QuestionList = ({
  questionCard,
  emptyMessage,
  bottomButtonType = EMPTY_QUESTIONS_BOTTOM_BUTTON_TYPE.WRITE,
  pageName,
  emptyComponent,
  onClickQuestion,
  advertisementComponent,
}: QuestionListProps) => {
  if (questionCard.isLoading) {
    return <QuestionsSkeleton />;
  }
  if (!questionCard.isLoading && !questionCard.data?.length) {
    if (emptyComponent) {
      return <>{emptyComponent}</>;
    }
    return (
      <EmptyQuestionList
        message={
          emptyMessage ?? {
            title: '등록된 질문이 없어요',
            description: '첫 질문을 남겨보세요.',
          }
        }
        bottomButtonType={bottomButtonType}
        pageName={pageName}
      />
    );
  }
  return (
    <>
      <InfiniteScroll
        rootMargin={'0px 0px 0px 100px'}
        isLoading={questionCard.isLoading}
        hasNextPage={questionCard.hasNextPage}
        fetchNextPage={questionCard.fetchNextPage}
      >
        {questionCard.data?.map((question, index) => {
          return (
            <Fragment key={`question-${question.question.questionPid}`}>
              {index % 10 === 0 && advertisementComponent}
              <QuestionItem
                isPaidQuestion={Boolean(question.paymentTotal)}
                key={question.question.questionPid}
                questionCard={question}
                onClickQuestion={onClickQuestion}
              />
            </Fragment>
          );
        })}
      </InfiniteScroll>
      <ScrollTopStickyButton />
    </>
  );
};

export default QuestionList;
